// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3MkNo","footer":"ModalError_footer__3gQdu"};